import { createDataHooks, createDriver } from '@wix/premium-fed-sdk/test-utils';
export const DATA_HOOKS = createDataHooks('site-selector-page', 'siteRow');
export const siteSelectorPageDriver = createDriver(DATA_HOOKS, driver => {
  const getSiteRows = () => {
    var _driver$component$get;
    return Array.from(((_driver$component$get = driver.component.get()) == null ? void 0 : _driver$component$get.querySelectorAll(`[data-hook="${DATA_HOOKS.siteRow}"]`)) ?? []);
  };
  return {
    getRenderedSitesCount: () => getSiteRows().length,
    isSiteNameRendered: siteName => getSiteRows().some(siteRow => {
      var _siteRow$textContent;
      return (_siteRow$textContent = siteRow.textContent) == null ? void 0 : _siteRow$textContent.includes(siteName);
    })
  };
});
//# sourceMappingURL=SiteSelectorPage.driver.js.map